// Libraries
var React = require('react');

// Styles
require('./MembershipGroup.scss');

// Components
var MembershipItem = require('./MembershipItem');

class MembershipGroup extends React.Component {
	render() {
		var items = null;

		items = this.props.memberships.memberships.map(function(membership, index) {
			return(<MembershipItem membership={membership} key={index} />)
		});

		return (
			<div className="MembershipGroup">
				{items.length > 0 &&
					<p>{this.props.memberships.name}</p>
				}
				{items}
			</div>
		)
	}
}

module.exports = MembershipGroup;



// WEBPACK FOOTER //
// ./src/components/Membership/MembershipGroup.js